export const CONSENT_INFO_MODAL = 'ConsentInfoModal';
export const ERROR_MODAL = 'ErrorModal';
export const GENERAL_MODAL = 'GeneralModal';
export const OK_MODAL = 'OkModal';
export const REGULATORY_ACCEPT_MODAL = 'RegulatoryAcceptModal';
export const FORGOT_PASSWORD_MODAL = 'ForgotPasswordModal';

export type ModalTypes =
  | typeof CONSENT_INFO_MODAL
  | typeof ERROR_MODAL
  | typeof GENERAL_MODAL
  | typeof OK_MODAL
  | typeof REGULATORY_ACCEPT_MODAL
  | typeof FORGOT_PASSWORD_MODAL;
